import {gql} from '@apollo/client';
import {HISTORY_DIFF_FRAGMENT} from '../../graphql/fragments';

export const GET_GENERIC_HISTORY_DIFF = gql`
  ${HISTORY_DIFF_FRAGMENT}

  query GetGenericHistoryDiff($entityId: UUID!, $entityType: OVModelsEnum!) {
    genericHistoryDiff(entityId: $entityId, entityType: $entityType) {
      ...HistoryDiffDetails
    }
  }
`;

export const GET_STAFF_HISTORY_DIFF = gql`
  ${HISTORY_DIFF_FRAGMENT}

  query GetStaffHistoryDiff($staffId: UUID!) {
    staffHistoryDiff(staffId: $staffId) {
      ...HistoryDiffDetails
    }
  }
`;

export const GET_GROUP_CHANGE_HISTORY = gql`
  ${HISTORY_DIFF_FRAGMENT}

  query GetGroupChangeHistory($daysSince: Int!) {
    groupChangeHistory(daysSince: $daysSince) {
      ...HistoryDiffDetails
    }
  }
`;
